export default "__VITE_ASSET__CUjD2DKg__"